<template>
  <div class="pushchannelmanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              border
              @row-click="rowClick">
      <el-table-column prop="createAtMY"
                       label="创建时间"
                       width="200"></el-table-column>

      <!-- <el-table-column label="邀约类型 " width="220">
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.appointUids === '0'">公开需求</p>
            <p style="color:#185ED3;" v-if="scope.row.appointUids !== '0'">定向需求(指定{{scope.row.appointUids.split(',').length}}人)</p>
            
          </div>
        </template>
      </el-table-column> -->

      <el-table-column prop="userName"
                       label="姓名"
                       width="200"></el-table-column>
      <el-table-column label="需求标题">
        <template slot-scope="scope">
          <span class="tit"
                :style="{'color' : isSimple ? '#FD9112' : '#5b9bd1','cursor': 'pointer'}">{{scope.row.title}}</span>
        </template>
      </el-table-column>

      <el-table-column v-if="false"
                       label="已收集图片">
        <template slot-scope="scope">
          <div style="display:flex;">
            <p style="margin-right:10px;"
               v-if="seepswIndex.indexOf(scope.$index) === -1">{{scope.row.zhang}}张/{{scope.row.ren}}人投稿</p>
            <p style="margin-right:10px;"
               v-if="seepswIndex.indexOf(scope.$index) !== -1">***张/***人投稿</p>

            <div @click="seePsw(scope.$index)"
                 :class="seepswIndex.indexOf(scope.$index) !== -1 ?'hidpsw':'seepsw'"></div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button @click="changeClick(scope)" type="text" class="btn" size="small">修改</el-button>
          <span style="margin:0 8px;"> | </span>
          <el-button @click="closeClick(scope)" type="text" class="btn" size="small">{{scope.row.status === 1?'关闭':'开启'}}</el-button>
          <span style="margin:0 8px;"> | </span>
          <el-button @click="delectClick(scope)" type="text" class="btn" size="small">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <el-dialog 
               :visible.sync="detailDialogVisible"
               width="70%"
               :before-close="handleClosedetail">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>我的邀约详情</div>
      </div>
      <div>
        <div style="text-align:center;font-size:15px;font-weight:600;margin-bottom:15px;">{{this.picMsg.title}}</div>
        <div style="display:flex;justify-content: space-around;">
          <div>发起人：{{this.picMsg.userName}}</div>
          <div>创建时间：{{this.picMsg.createAtMY}}</div>
        </div>
        <div style="width:80%;text-align:center;font-size:15px;font-weight:600;margin:25px auto;border-top:1px solid #cccccc;"></div>
        <div style="width:75%;margin:10px auto;">
          <div v-html="this.picMsg.content"
               style="height:420px;overflow-y: auto;box-sizing: border-box;padding:20px;box"></div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getPictureNeed } from "@/api/pictureNeed";
import { getUser } from "@/api/user";
export default {
  name: "pushchannelmanagetable",
  props: {
    tableData: Array,
  },
  data () {
    return {
      seepswFlag: false,
      seepswIndex: [],
      detailDialogVisible: false,
      picMsg: {}
      // tableData: [
      // {
      //   date: "2020-04-21",
      //   type: "公开需求",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // },
      // {
      //   date: "2020-04-21",
      //   type: "定向需求（指定5人）",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // },
      // {
      //   date: "2020-04-21",
      //   type: "定向需求（指定5人）",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // },
      // {
      //   date: "2020-04-21",
      //   type: "定向需求（指定5人）",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // }
      // ]
    };
  },
  methods: {


    //表格行点击效果
    rowClick (row, column, event) {
      this.picMsg = row
      this.getPictureNeedAsync(row.id)
      // this.detailDialogVisible = true
    },

    //图片邀约详情弹窗关闭事件
    handleClosedetail () {
      this.detailDialogVisible = false
    },







    closeClick (scope) {
      this.$emit("authClick", scope);
    },
    changeClick (scope) {
      this.$emit("changeClick", scope);
    },
    delectClick (scope) {
      this.$emit("delectClick", scope);
    },
    linkClick (scope) {
      // this.$emit('removeClick',scope)
      this.mydialogVisible = true;
    },
    quit () {
      this.mydialogVisible = false;
    },
    handleClose () {
      this.mydialogVisible = false;
    },
    seePsw (index) {
      // console.log(index)

      // this.seepswFlag = !this.seepswFlag
      if (this.seepswIndex.indexOf(index) === -1) {
        this.seepswIndex.push(index)
      } else {
        this.seepswIndex.splice(this.seepswIndex.indexOf(index), 1)
      }
      // console.log(this.seepswIndex)
    },


    //查询图片邀约
    async getPictureNeedAsync (val) {
      let { status, data, message, errors } = await getPictureNeed(val);
      if (status) {
        this.picMsg.content = data.content
        this.detailDialogVisible = true
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //查询图片邀约
    async getUserAsync (val) {
      let { status, data, message } = await getUser(val);
      if (status) {
        this.picMsg.userName = data.name

      } else {
        this.picMsg.userName = '用户一'

      }
    },
  },
  created () {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table {
  width: auto;
}
.seepsw {
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: url("~@/assets/house/nohidpsw.png") no-repeat;
}
.seepsw:hover {
  background: url("~@/assets/house/nohidpswh.png") no-repeat;
}
.hidpsw {
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: url("~@/assets/house/hidpsw.png") no-repeat;
}
.hidpsw:hover {
  background: url("~@/assets/house/hidpswh.png") no-repeat;
}
.el-table--enable-row-hover ::v-deep .el-table__body tr:hover {
  cursor: pointer;
}
.el-table ::v-deep .cell .tit:hover {
  text-decoration: underline !important;
}
</style>
